import React from "react";
import { Card, Radio, Input, Button } from "antd";

interface RegisteredPatientUIProps {
  scheme: string;
  registrationNumber: string;
  onSchemeChange: (e: any) => void;
  onRegistrationChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  schemes: any;
}

const RegisteredPatientUI: React.FC<RegisteredPatientUIProps> = ({
  scheme,
  registrationNumber,
  onSchemeChange,
  onRegistrationChange,
  onSubmit,
  schemes,
}) => {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Card
        style={{
          width: 450,
          borderRadius: "10px 0 10px 10px",
        }}
        styles={{
          body: {
            padding: "8px 16px",
          },
        }}
      >
        {/* Scheme Selection */}
        <Radio.Group
          value={scheme}
          onChange={onSchemeChange}
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 20,
          }}
          className="custom-radio"
        >
          {schemes
            ?.filter((s: any) =>
              ["CGHS NEW", "ECHS", "CAPF NEW"].includes(s?.schemeMetaDataName),
            )
            ?.map((s: any) => (
              <Radio key={s.schemeMetaDataId} value={s.schemeMetaDataId}>
                {s.schemeMetaDataName}
              </Radio>
            ))}
        </Radio.Group>

        {/* Registration Number */}
        <Input
          placeholder="Enter Registration Number"
          className="registration-no-input"
          size="small"
          value={registrationNumber}
          onChange={onRegistrationChange}
          style={{
            borderRadius: 10,
            padding: "4px 8px",
            marginBottom: 20,
            fontSize: 11
          }}
        />

        {/* Submit Button */}
        <Button
          type="primary"
          block
          size="large"
          style={{
            fontSize: 11,
            borderRadius: 10,
            backgroundColor: "#0d4b87",
          }}
          onClick={onSubmit}
        >
          Submit
        </Button>
      </Card>
    </div>
  );
};

export default RegisteredPatientUI;
